import COS from "cos-js-sdk-v5";


let cosUploading = null


class CosUploading {
    AppId = "1319321681"
    SecretId = localStorage.getItem("tmpSecretId")
    SecretKey = localStorage.getItem("tmpSecretKey")
    cos = null
    key = ""
    taskId = ""
    expireTime=localStorage.getItem("expireTime")
    sessionToken=localStorage.getItem("sessionToken")

    constructor() {
        this.cos = new COS({
            SecretId: this.SecretId,
            SecretKey: this.SecretKey,
            XCosSecurityToken:this.sessionToken
        })
    }

    uploadFileCos(key, file, onProgress, onFileFinish, onSuccess,onTaskReady) {
        this.cos.uploadFile({
            Bucket: localStorage.getItem("bucketName"),
            Region: localStorage.getItem("region"),
            Key: key,
            Body: file,
            ContentType: file.type,
            SliceSize: 1024 * 1024 * 5,
            onTaskReady: (taskId) => {
                /*this.taskId = taskId*/
                onTaskReady(taskId)

            },
            onProgress: (progressData) => {

                onProgress(progressData)
            },
            onFileFinish: (err, data, options) => {

                onFileFinish(err, data, options)
            },
        }, (err, data) => {
            onSuccess(err, data)
        });

    }
    cancelTask(taskId) {
        this.cos.cancelTask(taskId)
    }


}


function getCosUploading(forceUpdate = false) {
    // 强制更新或者ossUploading尚未初始化时，创建新的实例
    if (forceUpdate || cosUploading === null) {
        cosUploading = new CosUploading();
    }
    return cosUploading;
}



export default getCosUploading;
